import { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Container, Card, CardTitle, CardText, Button, InputGroup, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
//import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import {msalConfig } from '../services/msAuthConfig';
import {MSSignInButton} from './msSigninButton';
import { UserContext } from './UserContext';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { PageContext } from './PageContext';
import { useThemeSwitcher } from 'react-css-theme-switcher';
import { forgotPassword, validateAPIKey } from '../services/apiService';
import { useSearchParams } from 'react-router-dom';
import { changePassword } from '../services/apiAdminService';
import { Notification } from '@progress/kendo-react-notification';

export default function Login (){
    const [showLoginError, setShowLoginError]=useState(false);
    const [errorMsg, setErrorMsg]=useState('');
    const [showPassword, setShowPassword]=useState(false);
    const [username, setUserName]=useState('');
    const [password, setPassword]=useState('');
    const msalInstance = new PublicClientApplication(msalConfig);
    const userContext = useContext(UserContext);
    const user = userContext?.user;
    const onHideError =()=>setShowLoginError(false);
    const navigate = useNavigate();
    const pageContext=useContext(PageContext);
    //interface TogglePasswordEvent extends React.MouseEvent<HTMLButtonElement> {}
    const [showCookieWarning,setShowCookieWarning]=useState(true);
    const [showForgotPass,setShowForgotPass]=useState(false);
    const [forgotUser, setForgotUser]=useState("");
    const [forgotEmail, setForgotEmail]=useState("");

    const [showPassExpired,setShowPassExpired]=useState(false);
    const [newPass, setNewPass]=useState("");
    const [newPassConfirm, setNewPassConfirm]=useState("");

    const [SearchParams] = useSearchParams();
    const spUser = SearchParams.get('u');
    const spKey = SearchParams.get('k');
    const [isPassValid, setIsPassValid]=useState(false);
    const [invalidRequest, setInvalidRequest]=useState(false);

    const { switcher, themes, currentTheme, status } = useThemeSwitcher();

    function togglePassword(e: React.MouseEvent): void {
        e.preventDefault();
        console.log("Toggle password fires:");
        console.log(showPassword);
        setShowPassword(!showPassword);
    }; 

    const toggleShowLostPass=()=>{
      setShowForgotPass(!showForgotPass);
    }

    const toggleCookieWarning=()=>{
      setShowCookieWarning(!showCookieWarning);
    }

    const checkNewPass=()=>{
      if (newPass!="" && newPass===newPassConfirm){
        setIsPassValid(true);
      }else{
        setIsPassValid(false);
      }
    }

    const resetPassword=()=>{
        forgotPassword(forgotUser,forgotEmail).then(data=>{
          if (data=="MESSAGE SENT"){
            setShowForgotPass(false);
          }
          if (data=="UNAUTHORIZED"){
            setInvalidRequest(true);
          }
        });
    }

    const changeUserPassword=()=>{
      if (isPassValid){
        console.log("Ready to change password");
        if (spUser && spUser!==""){
          changePassword(spUser,newPass).then(data=>{
            console.log(data);
            if (data=="200"){
              setShowPassExpired(false);
            }            
          });
        }
      }
    }


    async function submitLogin(e: React.FormEvent<HTMLFormElement>): Promise<void> {
        e.preventDefault();
        console.log("Submit Login fires:");
        const isConverted: boolean = await checkUserConverted();
        console.log(isConverted);
        if (isConverted) {
            pageContext?.setShowLoading(true);
           const isValid: boolean = await validateUser();
           console.log(isValid);
            if (isValid) {
                navigate("/");
            }else{
              setErrorMsg("Invalid username or password.");
              setShowLoginError(true);
              pageContext?.setShowLoading(false);

            }
        }
    }

    async function checkUserConverted(){
        console.log("Check User Converted:");
        console.log(username);
        if (username!==''){
          if (password!==''){
            //userName and password supplied. Verify this is an active user
            const url = '/api/CheckUserConverted/'+username;
            console.log(url);
            try{
              const response = await fetch(url,{
                headers:{
                }
               });
              console.log(response);
              if(response.ok){
                const checkVal = await response.json();
                console.log(checkVal);
                switch(checkVal){
                  case 2:
                    //the user is good
                    console.log("The user is good");
                    return(true);
                  case 1:
                    //the user has not been converted
                    setErrorMsg('This user is not able to login at this time');
                    setShowLoginError(true);
                    return(false);
                  case 0:
                    //user does not exist
                    setErrorMsg('The user does not have an account');
                    setShowLoginError(true);
                    return(false);
                  default:
                    setErrorMsg('Something went wrong');
                    setShowLoginError(true);
                    return(false);
                }
              }
              else{
                throw new Error('CheckUserConverted response status: '+ response.status);
              }
            }
            catch(error){
              if (error instanceof Error) {
                console.error(error.message);
              } else {
                console.error('An unknown error occurred');
              }
              setErrorMsg('An error occurred');
              setShowLoginError(true);
              return(false);
            }
          }
          else{
            //password is blank. You must supply a password
            setErrorMsg('Please enter your password');
            setShowLoginError(true);
            return(false);
          }
        }
        else{
          //Username is blank. You must supply a username
          setErrorMsg('Please enter a user name');
          setShowLoginError(true);
          return(false);
        }
      } 

      async function validateUser(){
        console.log("Validate User " + username);
        const formData = new FormData();
        formData.append("username", username);
        formData.append("password", password);
        const url = "/api/Validate";
        console.log(url);
        try{
          const response = await fetch(url,{
            headers:{
            },
            method:"POST",
            body: formData
           }
          );
          if (!response.ok) {
            //throw new Error(`Response status: ${response.status}`);
            //invalid login
            return false;
          }else{            
            return true;  
          }
        }
        catch(error){
            if (error instanceof Error) {
                console.error(error.message);
              } else {
                console.error('An unknown error occurred');
              }
          return false;
        }
      }

      useEffect(()=>{
        checkNewPass();
      },[newPass])

      useEffect(()=>{
        checkNewPass();
      },[newPassConfirm])


      useEffect(()=>{
        if (spUser!=null && spKey!=null){
          validateAPIKey(spUser,spKey).then(data=>{
            if (data==="VALID"){
              setShowPassExpired(true);
            }
          })
        }
      },[])
    return(
        <div>
        {showCookieWarning?
        <Dialog >
          <div className="d-flex align-items-center align-self-center card p-3 text-center">
              <img src="img/CookieIcon.svg" width="150"/>
              {navigator.cookieEnabled?
                <p id="cookieNotice" className="mt-2">DPS AdTracker&trade;:Online uses cookies to personalize your user experience.<br/>By continuing you agree to our cookie policy.</p>
              :
                <p id="cookieDisabled" className="mt-2">DPS AdTracker&trade;:Online uses cookies to personalize your user experience.<br/>To continue you must allow cookies for this site.</p>
              }
              <p><a id="cookieLink" target="_blank" href={pageContext?.glSettings.CookieLink}>Cookie Policy</a>&emsp;<a id="privacyLink" target="_blank" href={pageContext?.glSettings.PrivacyLink}>Privacy Policy</a></p>                    
              <Button id="cookieAgree" type="button" className="btn btn-primary" onClick={toggleCookieWarning} >Agree</Button>
          </div>
        </Dialog>
        :null}
        {showForgotPass?
        <Dialog width={500}>
          <Alert color='danger' className='container-sm' isOpen={invalidRequest} toggle={onHideError} >Error! Invalid username/email combination. Please try again or contact customer support for assistance.</Alert>
          <div>
            <p>Please enter the email address associated with your ATOL account, then click SUBMIT. An email be sent to you with a link to reset your password.</p>
            <Input id="lostPassUser" className='mb-3' placeholder='Username' onChange={e=>setForgotUser(e.target.value)}/>
          </div>
          <div>
            <Input id="lostPassEmail" className='mb-3' placeholder='Email address' onChange={e=>setForgotEmail(e.target.value)}/>
          </div>
          <div>
            <Button color='primary' className='btn btn-lg btn-block' onClick={resetPassword}>Submit</Button>
            <Button color='secondary' className='btn btn-lg btn-block' onClick={toggleShowLostPass}>Cancel</Button>
          </div>
        </Dialog>
        :null}

        {showPassExpired?
        <Dialog width={500}>
          <div>
            <p>Your password has expired. You must update your password before you can proceed.</p>
            <Input id="lostPassUser" className='mb-3' type={"password"} placeholder='New Password' valid={isPassValid} onChange={e=>setNewPass(e.target.value)}/>
          </div>
          <div>
            <Input id="lostPassEmail" className='mb-3' type={"password"} placeholder='Confirm New Password' valid={isPassValid} onChange={e=>setNewPassConfirm(e.target.value)}/>
          </div>
          <div>
            <Button color='primary' className='btn btn-lg btn-block' onClick={changeUserPassword}>Submit</Button>
            <Button color='secondary' className='btn btn-lg btn-block' onClick={toggleShowLostPass}>Cancel</Button>
          </div>
        </Dialog>
        :null}


        <Container fluid style={{width: '30rem'}}>
        <Card body className='my-2 loginForm' style={{width: '24rem'}} data-bs-theme={currentTheme}>

            <h5>Welcome to DPS AdTracker™:Online</h5>
            <p>ATOL will allow you access to all your ad information in one click, the ability to chat with your Design Support Team and maintain a watchlist of ads that are a priority to you. If you do not have a log in for ATOL, please reach out to your Manager for assistance. If you are a Customer, please reach out to your Advertising Contact for help.</p>       
        <Alert color='danger' className='container-sm' isOpen={showLoginError} toggle={onHideError} >
            <strong>Error! {errorMsg}</strong>
        </Alert>
          <form onSubmit={submitLogin}>
            <CardTitle tag="h5">Sign in with DPS AdTracker</CardTitle>
            <Input 
                id="username"
                className='mb-3'
                placeholder='Enter your user name'
                onChange={e=>setUserName(e.target.value)}   
            />
            <InputGroup className='mb-3'>
              <Input 
                  id="password"
                  type={showPassword ? 'text':'password'}
                  placeholder='Enter your password'  
                  aria-describedby="btnShowPass"          
                  onChange={e=>setPassword(e.target.value)}
              />
              <Button onClick={togglePassword}>
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye}></FontAwesomeIcon>
              </Button>                  
            </InputGroup>
            <div className='d-flex justify-content-center mb-3'>
              <Button color='primary' type='submit' className='btn btn-lg btn-block'>Sign in</Button>
            </div>
            <div className='text-center'><a href="#" onClick={toggleShowLostPass}>Forgot my password</a></div>
            </form>           
          </Card>
        </Container>
        {/* <Container fluid>
          <div className='loginForm' style={{textAlign:'center'}}>
            <p>OR</p>
            <MsalProvider instance={msalInstance}>
              <MSSignInButton />
            </MsalProvider>
          </div>
        </Container> */}
        </div>
    );
}